import { __, getAEMUrl, getConfig } from "@jti/fe-common";
import { replaceStringPlaceholder } from "@jti/ui";
const getEventDisplayName = (item, messages) => {
    if (!messages || !item) {
        return "";
    }
    const translatedEvent = item.event ? __(item.event) : "";
    let displayName;
    const placeholdersConfig = [
        {
            placeholder: "event",
            value: translatedEvent,
        },
        {
            placeholder: "coupon",
            value: item.coupon_type === "url"
                ? `<a target="_blank" href='${item.coupon}'>${messages.externalCouponLinkLabel}</a>`
                : __(item?.coupon || ""),
        },
        {
            placeholder: "orderId",
            value: item.order_id || "",
        },
        {
            placeholder: "orderUrl",
            value: item.order_id
                ? `<a href='${getAEMUrl(`#/orders/${item.order_id}`, getConfig().PROFILE_PAGE_URL)}'>#${item.order_id}</a>`
                : "",
        },
    ];
    const pointsRedemptionMessage = item.order_id ? messages.pointsRedemptionMessage : translatedEvent;
    switch (item.type) {
        case "PointsWereAdded":
            displayName = item.order_id
                ? replaceStringPlaceholder(messages.pointsOrderAddedMessage, placeholdersConfig)
                : translatedEvent || messages.defaultPointsAddedMessage;
            break;
        case "PointsWereSpent":
            displayName = translatedEvent
                ? replaceStringPlaceholder(item.coupon ? messages.pointsCouponRedemptionMessage : pointsRedemptionMessage, placeholdersConfig)
                : messages.defaultPointsSpentMessage;
            break;
        case "PointsTransferHasBeenExpired":
            displayName = replaceStringPlaceholder(messages.pointsExpirationMessage, placeholdersConfig);
            break;
        case "PointsTransferHasBeenCanceled":
            displayName = replaceStringPlaceholder(messages.pointsCancellationMessage, placeholdersConfig);
            break;
        case "PointsWereRefunded":
            displayName = messages.pointsRefundMessage
                ? replaceStringPlaceholder(messages.pointsRefundMessage, placeholdersConfig)
                : __("loyalty.order_refund_points_message", [item.event]);
            break;
        default:
            displayName = translatedEvent;
            break;
    }
    return displayName;
};
export default getEventDisplayName;
//# sourceMappingURL=getEventDisplayName.js.map